import { createFileRoute } from '@tanstack/react-router';

import { RouteErrorBoundary } from '~/components/common/error-boundary/route-error-boundary';
import { RunShell } from '~/features/catalog-enrichment/components/run-shell';

/**
 * One run's frame: header + run tabs around every `/catalog-enrichment/runs/<runId>/*` page. Scoped
 * `errorComponent` (reusing the same boundary the root route falls back to) so an uncaught throw
 * in one tab's content (e.g. a Products-tab read that assumed a stage already existed) is
 * contained to this batch page instead of bubbling all the way to the root boundary and blanking
 * the whole app shell — the nearest ancestor with no `errorComponent` of its own, today's root.
 * TanStack's catch boundary replaces this route's own rendered output (`RunShell`, header/tabs
 * included) when it catches, so the batch's own chrome is not preserved across the error — only
 * the app shell around it (sidebar, top nav) is.
 */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/runs/$runId')({
  component: RouteComponent,
  errorComponent: RouteErrorBoundary,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  return <RunShell runId={runId} />;
}
